<template>
  <ag-modal-container
    title="Modification d'un utilisateur"
    width="800px"
    @close="back"
  >
    <user-form
      v-if="value"
      v-model="value"
      :optional-password="true"
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        :loading="loading"
        :disabled="!isValid || !value"
        color="primary"
        class="ml-5"
        @click="update"
        v-text="'Modifier'"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import UserForm from '../components/UserForm'

export default {
  name: 'UserUpdateContainer',
  components: {
    AgModalContainer,
    UserForm,
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isValid: false,
    loading: false,
    value: null,
  }),
  watch: {
    $route: {
      immediate: true,
      async handler () {
        this.value = await Repositories.user.get(this.userId)
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async update () {
      this.loading = true
      try {
        await Repositories.user.patch(this.value)
        this.showSuccessNotification(`La modification de ${this.value.login} est validé`)
        this.back()
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
